import { AppContextState } from "src/AppContextProvider";
import { FEATURE_FLAGS_ENUM } from "src/constants/featureFlag";

export const canAccessNotificationSettings = (context: AppContextState) => {
  return (
    context.shouldShowFeature(FEATURE_FLAGS_ENUM.SCREEN_NOTIFICATIONS) &&
    context.currentPermissions.validateOrg("screen", "delete")
  );
};
